import { put, take, call } from 'redux-saga/effects';
import {
  getAlarmsForEntityOverview,
  getAlarmsForEntityOverviewSuccess,
  setErrorMessage,
} from '../../../reducers/alarmEntityOverviewDetailsSlice';
import withLoading from '../../../sagas/loadingSaga';

export default function* alarmTablesSaga(api) {
  while (true) {
    const alarmsEntityOverviewAction = yield take(
      getAlarmsForEntityOverview.type,
    );
    const { entityId, currentFarmTimeInTFormat } =
      alarmsEntityOverviewAction.payload;
    yield* withLoading(function* () {
      yield call(
        getAlarmEntityOverviewDetails,
        api,
        entityId,
        currentFarmTimeInTFormat,
      );
    });
  }
}

function* getAlarmEntityOverviewDetails(api, entityId, toDate) {
  try {
    const alarmEntityOverviewDetails = yield call(
      api.getAlarmsDataForEntityOverview,
      entityId,
      toDate,
    );
    const alarmEntityOverviewResponse = alarmEntityOverviewDetails.data;
    yield put(getAlarmsForEntityOverviewSuccess(alarmEntityOverviewResponse));
  } catch (error) {
    yield put(setErrorMessage(error as string));
  }
}
